/**
 * Helper: Localize richtext
 * -----------------------------------------------------------------------------
 * Adds locale to richtext URLs when needed.
 *
 * @param {String} richtext - Shopify richtext setting data
 * @returns {String} Localized richtext
 *
 */

import localizeUrl from './localize-url'

export default (richtext = '') => {
  if (typeof richtext !== 'string' || !window.cnvs || window.cnvs?.routes?.root === '/') {
    return richtext
  }

  return richtext.replace(
    // eslint-disable-next-line prefer-named-capture-group
    /href="([^"]*)"/g,
    (_capture, match) => `href="${localizeUrl(match)}"`,
  )
}
